import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'app-icon-alerts-management',
    templateUrl: './alerts-management.component.svg',
    styleUrls: ['./alerts-management.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AlertsManagementComponent {}
